export const firebaseConfig = {
  apiKey: "AIzaSyCmugkYrectX8PaKalaJyv0XI2V-rTeN74",
  authDomain: "pairingscloud.firebaseapp.com",
  projectId: "pairingscloud",
  storageBucket: "pairingscloud.firebasestorage.app",
  messagingSenderId: "1012425502969",
  appId: "1:1012425502969:web:eafa11ecfda808bb27f228",
  measurementId: "G-PWKR5ECLMJ"
};